import React, { Fragment, useMemo, useState } from 'react';
import classNames from 'classnames';
import { STORE } from 'state/store/type';
import EmptyStoresList from './emptyStores';
import Info from './info';
import UtilisationInfo from './utilisationInfo';
import useAuth from 'state/auth/hooks/useAuth';
import { toast } from 'react-toastify';
import { useStoreNavigation } from 'utils/hooks/useStoreNavigation';
import { StoreListHeader } from 'components/stores/StoreListHeader';
import { OrgViewAccordion } from 'components/stores/OrgViewAccordion';
import { AssistanceFooter } from 'components/stores/AssistanceFooter';
import { StoreCommandPalette } from 'components/stores/StoreCommandPalette';
import { StoreListProps } from './types';

const ListStores = ({ storesList }: StoreListProps) => {
  const { auth } = useAuth();
  const { isNativeMode } = auth;
  const [commandOpen, setCommandOpen] = useState(false);

  const { handleStoreClick, handleOrgViewClick, handleAddStoreClick } =
    useStoreNavigation();

  const accessibleStoresCount = useMemo(() => {
    if (!storesList) return 0;
    return storesList.filter((store) => store.has_access).length;
  }, [storesList]);

  const handleStoreCardClick = (store: STORE.IStore) => {
    handleStoreClick(store, store.has_access, () =>
      toast.error("You don't have access to this store")
    );
  };

  const handleOrgClick = () => {
    if (storesList && storesList.length > 0) {
      handleOrgViewClick(storesList[0].organization_id);
    }
  };

  const hasStores = storesList && storesList.length > 0;

  return (
    <Fragment>
      {hasStores && (
        <StoreCommandPalette
          open={commandOpen}
          onOpenChange={setCommandOpen}
          storesList={storesList}
          accessibleStoresCount={accessibleStoresCount}
          onStoreSelect={handleStoreCardClick}
          onOrgViewSelect={handleOrgClick}
        />
      )}

      <div>
        <div
          className={classNames(
            'w-screen overflow-hidden flex bg-light-green-bg',
            isNativeMode ? 'h-screen py-4' : 'h-[calc(100vh-4rem)]'
          )}
        >
          {!hasStores ? (
            <EmptyStoresList />
          ) : (
            <div className="w-full flex flex-col items-center justify-between rounded-none bg-white m-0 lg:w-1/2 lg:items-start lg:rounded-3xl lg:m-3 lg:mx-6">
              <div className="w-full px-2 md:px-6 pt-4 md:pt-6">
                <StoreListHeader
                  storeCount={accessibleStoresCount}
                  onAddStore={handleAddStoreClick}
                />

                <div className="mt-4 mb-0 flex flex-col">
                  {storesList && (
                    <OrgViewAccordion
                      storesList={storesList}
                      accessibleStoresCount={accessibleStoresCount}
                      onStoreClick={handleStoreCardClick}
                      onOrgViewClick={handleOrgClick}
                    />
                  )}
                </div>
              </div>

              <AssistanceFooter />
            </div>
          )}

          {!hasStores ? (
            <Info />
          ) : (
            <Fragment>
              <UtilisationInfo />
            </Fragment>
          )}
        </div>
      </div>
    </Fragment>
  );
};

export default ListStores;
